module.exports = __webpack_public_path__ + "img/pic03.d3f478ae.png";